module.exports = __webpack_public_path__ + "img/sld_scb_38_t1_b1_green.17425533.svg";